import { IconContent } from '@icons';

export const plusCircleFilled: IconContent = {
    sm: '<path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm-.75-7.75V4.5h1.5v2.75h2.75v1.5H8.75v2.75h-1.5V8.75H4.5v-1.5h2.75Z" />',
};
